<template>
    <div class="login-fields-container">
        <div class="field-wrapper">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input class="login-field" type="password" :placeholder="placeholder" v-checkenter="login" v-model="password">
        </div>
        <div class="field-wrapper">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input class="login-field" type="password" :placeholder="placeholderConfirm" v-checkenter="login" v-model="confirmPassword">
        </div>
        <button class="login-button" @click.prevent="login"><p v-html="cta"></p></button>
    </div>
</template>

<script>
    import api from '@/services/api';
    import encrypt from '@/services/encrypt';

    export default {
        name: 'ForgotPassword',

        props: {
            placeholder: '',
            placeholderConfirm: '',
            cta: ''
        },

        data ()
        {
            return {
                password: '',
                confirmPassword: ''
            }
        },

        methods: {
            async login ()
            {
                
                if (this.password && this.confirmPassword)
                {
                    api
                        .post(`event/${this.$store.state.eventId}/createNewPassword`, {
                            password: await encrypt(this.password.trim()),
                            token: this.$route.params.token,
                        })
                        .then((response) => {
                            //console.log(response);
                            this.$emit('changed', true);
                        })
                        .catch((err, data) => {
                            this.$emit('changed', false);
                        });
                }
                else
                {
                    // show error
                    this.$emit('error', 'mismatch');
                }
            }
        },

        mounted ()
        {
            console.log('email mounted');
        }
        
    }
</script>

<style lang="scss">
    
</style>